import { Modal } from "antd";
import styled from "styled-components";

export const ModalStyled = styled(Modal)`
    .ant-modal-body {
        padding: 20px 32px;
    }

    .ant-modal-header {
        padding: 32px 32px 16px;
        margin: 0;
    }

    .ant-modal-footer {
        padding: 24px 32px;
        margin: 0;
        border-top: 1px solid ${props => props.theme.components.modal.borderColor};
        border-radius: 0 0 8px 8px;
    }

    .ant-modal-content {
        padding: 0;
    }

    .ant-modal-close {
        top: 28px;
        right: 32px;
    }

    .ant-table-summary {
        border-top: 1px solid ${props => props.theme.components.modal.borderDarkColor};
    }
`;
